import {
    CHECKOUT_SUBMIT,
    CHECKOUT_SUBMIT_ERROR,
    CHECKOUT_SET_CUSTOMER_INFO,
    CHECKOUT_SET_CAMPAIGN_CODE,
    CHECKOUT_SET_DELIVERY,
    CHECKOUT_SET_PAYMENT,
    CHECKOUT_SET_ORDER_NOTE,
    CHECKOUT_ACCEPT_TERMS_OF_CONDITION,
    CHECKOUT_SET_DISCOUNT_CODE,
    CHECKOUT_SET_PRIVATE_CUSTOMER,
    CHECKOUT_SET_PAYMENT_WIDGET,
    CHECKOUT_SET_SELECTED_COMPANY_ADDRESS,
    CHECKOUT_SET_SIGN_UP,
    CHECKOUT_SET_COUNTRY,
    CHECKOUT_SET_SHIPPING_OPTION,
    CHECKOUT_SET_USED_DISCOUNT_CODE,
    CHECKOUT_SET_STATUS_SUBMIT_BUTTON,
    CHECKOUT_SET_SHIPMENT_WIDGET,
    CHECKOUT_SET_UNIFAUN_LOADING,
    CHECKOUT_SET_UNIFAUN_DELIVERY_CHECKOUT,
    CHECKOUT_SET_UNIFAUN_SELECTED_SHIPPING_RESULT,
    CHECKOUT_SET_UNIFAUN_ZIPCODE,
    CHECKOUT_SET_QLIRO_CUSTOMER_INFO,
    CHECKOUT_SET_DELIVERY_FORMAT,
    CHECKOUT_SET_UNIFAUN_DELIVERY_CHECKOUTS,
    CHECKOUT_SET_UNIFAUN_SELECTED_SHIPPING_FOR_GROUP,
    CHECKOUT_SET_UNIFAUN_DELIVERY_GROUPS,
} from '../Actions/Checkout.action';
import { error as errorReducer } from './Error.reducer';

const defaultState = { 
    payload: {
        alternativeAddress: {},
        customerDetails: {},
        selectedCompanyAddressId: null,
        selectedDeliveryMethod: {},
        selectedPaymentMethod: {},
        selectedCountry: {},
        discountCode: '',
        orderNote: {},
        paymentWidget: null,
        isBusinessCustomer: false,
        signUp: false,
        acceptTermsOfCondition: false,

        authenticated: false,
        deliveryMethods: [],
        paymentMethods: [],
        companyAddresses: [],
        responseUrl: '',
        cancelUrl: '',
        redirectUrl: '',
        qliroCustomerInfo: null,
        unifaunSelectedShipping: { valid: false },
        unifaunZipCode: '',
        splitDelivery: true,
        unifaunSelectedShippings: {},
        unifaunDeliveryGroups: [],
    },
    errors: {},
    result: {},
    isSubmitting: false,
    unifaunLoading: false,
    unifaunDeliveryCheckout: {},
    unifaunDeliveryCheckouts: {},
}

export const checkout = (state = defaultState, action) => {
    // Ensure splitDelivery defaults to true when preloaded state doesn't include it
    if (state.payload && state.payload.splitDelivery === undefined) {
        state = { ...state, payload: { ...state.payload, splitDelivery: true } };
    }
    const { type, payload } = action;
    switch (type) {
        case CHECKOUT_SUBMIT_ERROR:
            return {
                ...state,
                errors: errorReducer(state.errors, action)
            }
        case CHECKOUT_SUBMIT:
        case CHECKOUT_SET_STATUS_SUBMIT_BUTTON:
        case CHECKOUT_SET_UNIFAUN_LOADING:
        case CHECKOUT_SET_UNIFAUN_DELIVERY_CHECKOUT:
        case CHECKOUT_SET_UNIFAUN_DELIVERY_CHECKOUTS:
            return {
                ...state,
                ...payload,
            };
        case CHECKOUT_SET_UNIFAUN_SELECTED_SHIPPING_FOR_GROUP: {
            const newShippings = {
                ...state.payload.unifaunSelectedShippings,
                [payload.groupKey]: payload.unifaunSelectedShipping,
            };
            const allValid = Object.keys(newShippings).length > 0
                && Object.values(newShippings).every(s => s && s.valid);
            return {
                ...state,
                payload: {
                    ...state.payload,
                    unifaunSelectedShippings: newShippings,
                    unifaunSelectedShipping: { valid: allValid },
                },
            };
        }
        case CHECKOUT_SET_CUSTOMER_INFO:
            return {
                ...state,
                payload: {
                    ...state.payload,
                    [payload.key]: {
                        ...state.payload[payload.key],
                        ...payload.data,
                    }
                },
            }
        case CHECKOUT_SET_DELIVERY:
        case CHECKOUT_SET_PAYMENT:
        case CHECKOUT_SET_ORDER_NOTE:
        case CHECKOUT_SET_PAYMENT_WIDGET:
        case CHECKOUT_SET_SHIPMENT_WIDGET:
        case CHECKOUT_SET_PRIVATE_CUSTOMER:
        case CHECKOUT_SET_SIGN_UP:
        case CHECKOUT_SET_SELECTED_COMPANY_ADDRESS:
        case CHECKOUT_ACCEPT_TERMS_OF_CONDITION:
        case CHECKOUT_SET_DISCOUNT_CODE:
        case CHECKOUT_SET_CAMPAIGN_CODE:
        case CHECKOUT_SET_COUNTRY:
        case CHECKOUT_SET_USED_DISCOUNT_CODE:
        case CHECKOUT_SET_SHIPPING_OPTION:
        case CHECKOUT_SET_UNIFAUN_SELECTED_SHIPPING_RESULT:
        case CHECKOUT_SET_UNIFAUN_ZIPCODE:
        case CHECKOUT_SET_QLIRO_CUSTOMER_INFO:
        case CHECKOUT_SET_DELIVERY_FORMAT:
        case CHECKOUT_SET_UNIFAUN_DELIVERY_GROUPS:
            return {
                ...state,
                payload: {
                    ...state.payload,
                    ...payload,
                }
            }
        default:
            return state;
    }
}